import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOnDutyRoutine(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_duty_routine">
      <h2 className="pop_tit">당직 루틴등록</h2>
      <div className="content_container scroll mb_no">
        <div className="pop_cont com_red_txt">
          * 선택된 인원이 자동 루틴 됩니다. <br />* 여자직원은 일, 공휴일에만 근무하게 됩니다.
        </div>
        <div className="com_input_sec">
          <div className="check center">
            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
            <label htmlFor="rdo01">평일</label>
            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
            <label htmlFor="rdo02">토요일</label>
            <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
            <label htmlFor="rdo03">일요일& 공휴일</label>
          </div>
        </div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="60" />
            <col width="auto" />
          </colgroup>
          <tbody>
            <tr>
              <th>1</th>
              <td>
                <select name="" id="" className="select ws">
                  <option value="">김관리</option>
                </select>
              </td>
            </tr>
            {[...Array(10)].map((i, idx) => (
              <tr key={idx}>
                <th>{idx + 1}</th>
                <td>최길동325</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopOnDutyRoutine;
